import { defineComponent as Z, useSlots as R, useTemplateRef as A, ref as C, computed as s, useId as z, onMounted as ee, createElementBlock as b, createCommentVNode as i, openBlock as o, createElementVNode as k, createBlock as h, resolveDynamicComponent as y, withCtx as te, createTextVNode as le, toDisplayString as I, toRaw as L, normalizeClass as g, createVNode as ae } from "vue";
import { useResizeObserver as re, useMutationObserver as se } from "@vueuse/core";
import "@ds/components/Button";
import { deprecatePropNames as ne } from "../../composables/usePropsDeprecation.js";
import { tw as W } from "../../utils/tailwind.js";
import { skipFragment as oe, isVNodeEmpty as ie } from "../../utils/vnode.js";
import { desktopCardWidths as $, mobileCardWidths as D, cardWidths as de, SCROLL_ANNOUNCEMENT_DELAY as ue } from "./CardCarousel.constant.js";
import O from "./components/CardCarouselController.vue2.js";
import ce from "./components/CardCarouselItems.vue2.js";
const me = ["aria-labelledby"], ve = {
  key: 0,
  class: "mb-16 inline-flex flex-row items-end gap-16 md:gap-28"
}, pe = { class: "flex grow flex-col" }, he = ["id"], fe = ["aria-label"], be = {
  key: 1,
  class: "isolate mt-8 flex"
}, Be = /* @__PURE__ */ Z({
  name: "CardCarousel",
  __name: "CardCarousel",
  props: {
    desktopCardWidth: { default: "standard" },
    mobileCardWidth: { default: "standard" },
    prevAlternativeText: {},
    nextAlternativeText: {},
    size: { default: "small" },
    title: { default: "" },
    titleTag: { default: "h2" },
    subtitle: { default: "" }
  },
  setup(M) {
    const r = M, n = R(), t = A("carousel-scroller"), P = A(
      "carousel-items"
    ), d = C(!1), u = C(!1), w = s(() => `${z()}_title`), T = s(() => `${z()}_subtitle`), m = s(() => d.value || u.value), F = s(() => [
      d.value && u.value && W`gradient-mask-lr-80`,
      d.value && !u.value && W`gradient-mask-l-90`,
      !d.value && u.value && W`gradient-mask-r-90`
    ]), N = C(""), _ = s(
      () => oe(n == null ? void 0 : n.default({})).filter(
        (e) => !ie(e)
      )
    ), B = (e) => {
      var a, c, v;
      const l = {
        backward: -1 * (((a = t == null ? void 0 : t.value) == null ? void 0 : a.clientWidth) ?? 0),
        forward: ((c = t == null ? void 0 : t.value) == null ? void 0 : c.clientWidth) ?? 0
      };
      (v = t == null ? void 0 : t.value) == null || v.scrollBy({
        behavior: "smooth",
        left: l[e],
        top: 0
      });
    }, j = (e, l) => {
      const a = e.getBoundingClientRect();
      return a.left >= l.left && a.right <= l.right && a.top >= l.top && a.bottom <= l.bottom;
    }, S = (e) => {
      B(e), setTimeout(() => {
        var E;
        const l = t.value, a = (E = P.value) == null ? void 0 : E.$el;
        if (!l || !a) return;
        const c = l.getBoundingClientRect(), X = Array.from(a.children).filter(
          (x) => j(x, c)
        ).map((x) => {
          var V;
          return (V = x.textContent) == null ? void 0 : V.trim();
        }).filter(Boolean).join(", ");
        N.value = X;
      }, ue);
    }, U = async () => {
      var a, c, v;
      const e = ((a = t == null ? void 0 : t.value) == null ? void 0 : a.scrollWidth) ?? 0, l = (((c = t == null ? void 0 : t.value) == null ? void 0 : c.clientWidth) ?? 0) + (((v = t == null ? void 0 : t.value) == null ? void 0 : v.scrollLeft) ?? 0);
      u.value = l < e;
    }, Y = () => {
      var e;
      d.value = ((e = t == null ? void 0 : t.value) == null ? void 0 : e.scrollLeft) !== 0;
    }, f = () => {
      U(), Y();
    };
    ee(() => {
      f();
    });
    const p = s(() => {
      var e, l;
      return (l = (e = n == null ? void 0 : n.button) == null ? void 0 : e.call(n, {})) != null && l[0] ? n.button({})[0] : null;
    }), q = s(() => {
      var e;
      return !((e = _.value) != null && e.length);
    }), G = s(() => r.desktopCardWidth === "narrow" ? [
      $[r.desktopCardWidth],
      D[r.mobileCardWidth]
    ] : [
      $[r.desktopCardWidth],
      D[r.mobileCardWidth],
      de[r.size]
    ]), H = s(() => p.value && !m.value), J = s(() => p.value || m.value && !r.title), K = s(() => ["hidden md:flex", r.title && "md:ml-auto"]), Q = s(() => [
      r.title && "md:ml-auto",
      r.title && !m.value && "md:hidden"
    ]);
    return re(t, () => {
      f();
    }), se(
      t,
      () => {
        f();
      },
      { attributes: !0, childList: !0, subtree: !0 }
    ), ne([
      {
        reason: "Replaced by `size`, with new values `extra-small`, `small`, `medium`, `large` and `extra-large`",
        deadline: "2025-05-01",
        replacementName: "size",
        props: {
          propName: "desktopCardWidth",
          propValue: r.desktopCardWidth,
          propDefaultValue: "standard"
        }
      },
      {
        reason: "Replaced by `size`, with new values `extra-small`, `small`, `medium`, `large` and `extra-large`",
        deadline: "2025-05-01",
        replacementName: "size",
        props: {
          propName: "mobileCardWidth",
          propValue: r.mobileCardWidth,
          propDefaultValue: "standard"
        }
      }
    ]), (e, l) => q.value ? i("", !0) : (o(), b("section", {
      key: 0,
      "aria-labelledby": `${w.value} ${T.value}`,
      "aria-roledescription": "carousel",
      class: "relative flex flex-col",
      "data-test": "card-carousel"
    }, [
      e.title ? (o(), b("div", ve, [
        k("div", pe, [
          (o(), h(y(e.titleTag), {
            id: w.value,
            class: "text-static-default-hi heading-2 mb-8 md:mb-0"
          }, {
            default: te(() => [
              le(I(e.title), 1)
            ]),
            _: 1
          }, 8, ["id"])),
          e.subtitle ? (o(), b("span", {
            key: 0,
            id: T.value,
            class: "text-static-default-low body-1"
          }, I(e.subtitle), 9, he)) : i("", !0)
        ]),
        m.value ? (o(), h(O, {
          key: 0,
          "can-scroll-next": u.value,
          "can-scroll-prev": d.value,
          "next-alternative-text": e.nextAlternativeText,
          "prev-alternative-text": e.prevAlternativeText,
          onScroll: S
        }, null, 8, ["can-scroll-next", "can-scroll-prev", "next-alternative-text", "prev-alternative-text"])) : i("", !0),
        H.value ? (o(), h(y(L(p.value)), {
          key: 1,
          class: g(K.value),
          "full-width": "adaptive"
        }, null, 8, ["class"])) : i("", !0)
      ])) : i("", !0),
      k("div", {
        ref: "carousel-scroller",
        class: g(["focus-visible-outline-inset-hi rounded-sm -m-12 snap-x snap-mandatory scroll-pl-12 overflow-x-auto overscroll-x-contain scroll-smooth transition-transform duration-700 scrollbar-none", F.value]),
        onScroll: f
      }, [
        ae(ce, {
          ref: "carousel-items",
          "card-classes": G.value,
          center: !m.value,
          class: "p-12",
          items: _.value
        }, null, 8, ["card-classes", "center", "items"]),
        k("div", {
          "aria-label": N.value,
          "aria-live": "polite",
          class: "sr-only"
        }, null, 8, fe)
      ], 34),
      J.value ? (o(), b("div", be, [
        p.value ? (o(), h(y(L(p.value)), {
          key: 0,
          class: g(Q.value),
          "full-width": "adaptive"
        }, null, 8, ["class"])) : i("", !0),
        m.value && !e.title ? (o(), h(O, {
          key: 1,
          "can-scroll-next": u.value,
          "can-scroll-prev": d.value,
          class: "ml-auto",
          "next-alternative-text": e.nextAlternativeText,
          "prev-alternative-text": e.prevAlternativeText,
          onScroll: B
        }, null, 8, ["can-scroll-next", "can-scroll-prev", "next-alternative-text", "prev-alternative-text"])) : i("", !0)
      ])) : i("", !0)
    ], 8, me));
  }
});
export {
  Be as default
};
